import { FastLinkMenuSchoolsApiResponseModel } from './fastLinksMenu.model';
import { fastLinkMenuItemAdapter } from '../fastLinksMenu.adapter';
import { FastLinkMenuItemModel } from '../fastLinksMenu.model';

export const fastLinksMenuSchoolsResponseAdapter = ({
  data,
}: FastLinkMenuSchoolsApiResponseModel): FastLinkMenuItemModel[] =>
  data.data.map(fastLinkMenuItemAdapter);
